import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.0566 13H3.94336C3.10459 13 2.68455 12.1059 3.27763 11.583L9.33427 6.24311C9.70192 5.91896 10.2981 5.91896 10.6657 6.24311L16.7223 11.583C17.3155 12.1059 16.8954 13 16.0566 13Z",
		fill: "#0D2976"
	})
});
export default SvgCaretUp;
